import instObj from '@/backend/axios-instances'

const resource = "/products/subcategory"
const instance = instObj.baseInstance

export default {
  get(productCategoryId, parameters) {
    return instance.get(`${resource}/${productCategoryId}`, { params: parameters });
  },
  put(productCategoryId, data, parameters) {
    return instance.put(`${resource}/${productCategoryId}`, data, { params: parameters });
  },
  delete(productCategoryId) {
    return instance.delete(`${resource}/${productCategoryId}`);
  }
}
